<template>
  <div class="card-box" @click="goDetail()">
    <div class="card-pic">
      <div v-if="tag" class="tips-tag" :class="statusColor">{{ tag }}</div>
      <el-image class="cover-photo" :src="cardData.live_cover || cover" fit="cover" />
    </div>
    <div class="card-title">
      <h3>{{ cardData.title }}</h3>
      <span class="title-tag">{{ cardData.type }}</span>
    </div>
    <div class="time-info">
      <i class="el-icon-time" />
      <span>{{ cardData.live_time }}</span>
    </div>
  </div>
</template>
<script>
import cover from '@/assets/images/default_cover.png'
export default {
  props: {
    cardData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      cover,
    }
  },
  computed: {
    tag() {
      switch (this.cardData.status) {
        case 2:
          return '未开始'
        case 3:
          return '直播中'
        case 1:
          if (this.cardData.review_url) {
            return '有回放'
          } else {
            return '已结束'
          }
        default:
          return ''
      }
    },
    statusColor() {
      switch (this.cardData.status) {
        case 1:
          return 'end-clor'
        case 2:
          return 'ready-clor'
        case 3:
          return 'living-clor'
        default:
          return 'end-clor'
      }
    },
  },
  methods: {
    goDetail() {
      if (this.cardData.status === 3 && this.cardData.live_url) {
        window.location.href = this.cardData.live_url
      } else {
        this.$router.push({
          path: `/broadcast/detail/${this.cardData.id}`,
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.card-box {
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  background-color: #ffffff;
  transition: all 0.15s ease-in-out;
  background-image: url('/robots/images/icons/mike.png');
  background-size: 60px 60px;
  background-repeat: no-repeat;
  background-position: bottom 20px right 10px;
  cursor: pointer;

  &:hover {
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.1);
    transform: translateY(-5px);
    transition: transform 0.15s;
  }

  .card-pic {
    width: 100%;
    height: 220px;

    .tips-tag {
      position: absolute;
      padding: 6px 12px;
      top: 18px;
      right: 18px;
      font-size: 16px;
      border-radius: 6px;
      color: #ffffff;
      z-index: 2;

      &.end-clor {
        background-color: #a0a0a0;
      }
      &.ready-clor {
        background-color: #24b9a7;
      }
      &.living-clor {
        background-color: #ffa600;
      }
    }

    .cover-photo {
      width: 100%;
      height: 100%;
    }
  }

  .card-title {
    padding: 16px 20px;
    border-top: 12px solid #66d5c8;

    h3 {
      height: 44px;
      font-size: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .title-tag {
      margin-top: 10px;
      width: fit-content;
      height: 24px;
      padding: 0 12px;
      font-size: 12px;
      background-color: #e4ebff;
      color: #3160f6;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
    }
  }

  .time-info {
    padding: 0 20px 16px;
    span {
      margin-left: 5px;
    }
  }
}
</style>
